import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ReturnsIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M7.152 5.859a.499.499 0 0 1 0-.718l2.994-2.995a.5.5 0 1 1 .708.708L8.707 5H11.5C13.933 5 16 7.01 16 9.5S13.933 14 11.5 14H.5a.5.5 0 0 1 0-1h11c1.889 0 3.5-1.57 3.5-3.5S13.389 6 11.5 6H8.707l2.147 2.146a.5.5 0 1 1-.707.708L7.151 5.859Z" />
  </IconWrapper>
)

export default ReturnsIconSmall
